export default "__VITE_ASSET__YebPNLmB__"